import {FETCH_SAMPLE_SIZE, UPDATE_SAMPLE_SIZE, FETCH_MULTI_SAMPLE_SIZE, FETCH_SAMPLE_SIZE_SUCCESS, FETCH_MULTI_SAMPLE_SIZE_SUCCESS, FETCH_SAMPLE_SIZE_ERROR, FETCH_MULTI_SAMPLE_SIZE_ERROR, RESET_SAMPLE_SIZE} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  loadingMulti: false,
  data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_SAMPLE_SIZE: {
      return {...state, error: '', loading: true};
    }
    case FETCH_MULTI_SAMPLE_SIZE: {
      return {...state, error: '', loadingMulti: true};
    }
    case FETCH_SAMPLE_SIZE_SUCCESS: {
      const newData = [...state.data];
      newData[action.payload.index] = action.payload.sample && action.payload.sample.sample_size ? action.payload.sample.sample_size : 0;
      return {...state, error: '', data: newData, loading: false};
    }
    case FETCH_MULTI_SAMPLE_SIZE_SUCCESS: {
      const newData = action.payload && action.payload.samples ? action.payload.samples.map(sample => sample && sample.data ? sample.data.sample_size : 0) : [];
      return {...state, error: '', data: newData, loadingMulti: false};
    }
    case FETCH_SAMPLE_SIZE_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case FETCH_MULTI_SAMPLE_SIZE_ERROR: {
      return {...state, loadingMulti: false, error: action.payload};
    }
    case UPDATE_SAMPLE_SIZE: {
      const { params } = action;
      const newData = state.data.map((e, i) => params[i] === 0 ? 0 : e);
      return {...state, data: newData};
    }
    case RESET_SAMPLE_SIZE: {
      return INIT_STATE;
    }
    default:
      return state;
  }
}
